import { Reducer } from 'redux';
import { IAction } from '../types';

interface Game {
  name?: string;
}

export interface BreadcrumbInfoState {
  gameInfo?: Game;
}

export const breadcrumb: BreadcrumbInfoState = {
  gameInfo: {}
};

export const setCurrentGame: (payload: BreadcrumbInfoState) => IAction<BreadcrumbInfoState> = (
  payload: BreadcrumbInfoState
) => ({
  type: 'setCurrentGame',
  payload
});

const breadcrumbReducer: Reducer<BreadcrumbInfoState, IAction<any>> = (state = breadcrumb, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setCurrentGame':
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default breadcrumbReducer;
